import { FunctionComponent, useState } from "react";

import { faTrash } from "@fortawesome/pro-regular-svg-icons";

import { InputField } from "@/components/InputField/InputField";
import { Icon } from "@/components/Icon/Icon";

interface AllowedValuesBySchemaProps {
	allowedValues: string[];
	onAdd: (value: string) => void;
	onRemove: (value: string) => void;
}

export const AllowedValuesBySchema: FunctionComponent<AllowedValuesBySchemaProps> = ({
	allowedValues,
	onAdd,
	onRemove,
}) => {
	const [newValue, setNewValue] = useState<string>("");

	const handleKeyDown = (e: React.KeyboardEvent<HTMLInputElement | HTMLTextAreaElement>) => {
		if (e.key === "Enter" && !!newValue?.trim()) {
			const alreadyAdded = allowedValues.includes(newValue);

			if (alreadyAdded) {
				setNewValue("");

				return;
			}

			onAdd(newValue);
			setNewValue("");
		}
	};

	return (
		<div className="flex flex-col w-full mt-4">
			<InputField
				handleChange={(e) => setNewValue(e.target.value)}
				label="Allowed Values"
				name="allowedValues"
				placeholder="Enter allowed values"
				value={newValue}
				onKeyDown={handleKeyDown}
			/>
			<div className="flex flex-col w-full mt-4">
				{allowedValues.length > 0 && (
					<div className="text-sm font-medium text-text-meta mb-2">Allowed Values</div>
				)}
				{allowedValues.map((value: string) => (
					<div
						key={value}
						className="flex flex-row items-center justify-between py-2 px-4 rounded-xl border border-border-light mb-2"
					>
						{value}{" "}
						<Icon
							className="text-red-500 cursor-pointer"
							icon={faTrash}
							onClick={() => onRemove(value)}
						/>
					</div>
				))}
			</div>
		</div>
	);
};
